import { useAppBuilderContext } from 'app/app/editor/context';
import React, { useEffect, useRef, useState } from 'react';
import { merge } from 'ts-deepmerge';
import { IComponentNode } from 'app/app/editor/index.functions';
import StylesEditorContainer from 'app/app/editor/tabs/settings/style-editor/StylesEditorContainer';

export default function StylesEditor({ node }: { node: IComponentNode }) {
    const ctx = useAppBuilderContext();

    const [formState, setFormState] = useState<{ [key: string]: any }>({});
    const formStateRef = useRef(formState);
    useEffect(() => {
        formStateRef.current = formState;
    }, [formState]);
    const [isChange, setIsChange] = useState(false);

    useEffect(() => {
        setFormState(node.params?.layout?.styles ?? {});
    }, [node.params.uid]);

    useEffect(() => {
        setTimeout(() => {
            if (node.params.layout?.styles?.width && node.params.layout?.styles?.height) {
                if (
                    formStateRef.current?.width != node.params.layout.styles.width ||
                    formStateRef.current?.height != node.params.layout.styles.height
                ) {
                    setFormState({
                        ...formStateRef.current,
                        width: node.params.layout.styles.width,
                        height: node.params.layout.styles.height,
                        'size-type-width': node.params.layout.styles['size-type-width'],
                        'size-type-height': node.params.layout.styles['size-type-height'],
                    });
                }
            }
        }, 0);
    }, [
        node.params.layout?.styles?.width,
        node.params.layout?.styles?.height,
        node.params.layout?.styles?.['size-type-width'],
        node.params.layout?.styles?.['size-type-height'],
    ]);

    const applyChanges = () => {
        node.params.layout = {
            ...node.params?.layout,
            styles: merge(node.params?.layout?.styles ?? {}, structuredClone(formStateRef.current)),
        };
        ctx.setPage(ctx.page, false);
        ctx.sendMessage({
            name: 'updateComponent',
            data: { uid: node.params.uid, updateType: 'style' },
            broadcast: false,
        });
        // Prevent rendering all components on apply style changes
        // ctx.sendMessage({ name: 'reloadPage' });
    };

    const onChangeStyle = (newData: any) => {
        setFormState((prevState) => ({ ...prevState, ...newData }));
        setIsChange(true);
    };

    useEffect(() => {
        if (isChange) {
            applyChanges();
        }
        setIsChange(false);
    }, [formState]);

    if (!node) {
        return null;
    }

    return (
        <StylesEditorContainer
            key={node.params.uid}
            uid={node.params.uid}
            formState={formState}
            setFormState={setFormState}
            onChangeStyle={onChangeStyle}
            node={node}
        />
    );
}
